import { orpc } from "@/utils/orpc.client";

interface SearchDiscoveryQueryOptionsInput {
  enabled?: boolean;
}

export function getSearchDiscoveryQueryOptions(input: SearchDiscoveryQueryOptionsInput = {}) {
  return orpc.music.getSearchDiscoverySeeds.queryOptions({
    input: {},
    enabled: input.enabled,
  });
}
